const baseURL  = '/app';
// const baseURL  = '/pes';

export {
    baseURL
}